import { GoogleLogin } from '@react-oauth/google';
import React from 'react';
import DebugService from '../services/DebugService';

/**
 * Google Sign Up Component
 * @param {*} props 
 * @returns 
 */
const GoogleSignUp = (props) => {
  const label = props.label ?? 'Google'

  /**
   * @description Google sign in success response handler
   * @param {*} response 
   */
  const handleSuccess = (response) => {
    DebugService.log('GoogleSignUp Component: Sign up success response', response);
    props['handleSuccess'](response)
  };

  /**
   * @description Google sign in failure response handler
   * @param {*} error 
   */
  const handleFailure = (error) => {
    DebugService.error('Google sign-up error:', error);
    props['handleFailure'](error)
  };

  return (
    <div>
      <GoogleLogin
        buttonText={label}
        onSuccess={handleSuccess}
        onFailure={handleFailure}
        cookiePolicy={'single_host_origin'}
      />
    </div>
  );
};

export default GoogleSignUp;